import { DataService } from './../../service/data/data.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { BehaviorSubject, Observable, catchError,  switchMap, take, throwError } from 'rxjs';
import { AuthService } from '../../../auth/auth.service';
import { TokenService } from '../../service/token/token.service';
import { RefreshTokenResponse } from './../../models/auth.model';
import { environment } from '../../../../environments/environment';
import { CommonService } from '../../core.index';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<unknown> = new BehaviorSubject<unknown>(null);

  constructor(private authService:AuthService,
    private dataService:DataService,
    private tokenService:TokenService,
    private cs: CommonService) {}

  intercept(request: HttpRequest<string>, next: HttpHandler): Observable<HttpEvent<string>> {
    let token = this.tokenService.getJwtToken();
    
    // If worker token exists, override employee token
    const workerToken = this.cs.worker_token;
    if (workerToken && workerToken !== '' && workerToken != null) {
      token = workerToken;
    }
    
    // // Authentication Interceptor:add authentication tokens or headers to every outgoing HTTP request.
    if(token){
      request = this.addToken(request, token);
    }
    // request = this.addApiKey(request);
    // Error Handling Interceptor
    return next.handle(request).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        return this.handle401Error(request, next);
      }
      else {
        return throwError(()=>error);
      }
    }));
    // return next.handle(request);
  }
  // handle error:
  private handle401Error(request: HttpRequest<string>, next: HttpHandler) {
    const refresh_token = this.tokenService.getRefreshToken();
    if(refresh_token && refresh_token.length){
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      // Set the refreshTokenSubject to null so that subsequent API calls will wait until the new token has been retrieved
      this.refreshTokenSubject.next(null);

      return this.authService.refreshToken({
        refresh_token: refresh_token?refresh_token:''
      }).pipe(
        switchMap((token: RefreshTokenResponse) => {
          this.isRefreshing = false;
          this.tokenService.storeTokens(token);
          this.refreshTokenSubject.next(token.access_token);
          return next.handle(this.addToken(request, token.access_token));
        }),
      );
    }  else {
      return this.refreshTokenSubject.pipe(
        // If isRefreshing is true, we will wait until refreshTokenSubject has a non-null value
        // which means the new token is ready and we can retry the request again
        take(1),
        switchMap((jwt) => {
           // Refresh token failed, navigate to login
          if(jwt == null){
            this.authService.logout();
          }
          return next.handle(this.addToken(request, jwt));
          // this.authService.logout();
        })
      );
    }
    } else {
      this.authService.logout();
      return throwError(()=>Error);
    }
  }

  private addToken(request: HttpRequest<string>, token: unknown) {
    // const token_type = this.tokenService.getTokenType();
    const token_type = (this.cs.worker_token && this.cs.worker_token !== '' && this.cs.worker_token != null) ? 'Bearer' : this.tokenService.getTokenType();
    const iframe = localStorage.getItem('iframe');

    // Clone the request and replace the original headers with cloned headers, updated with the authorization.
    return request.clone({
      setHeaders: {
        'Authorization': `${token_type} ${token}`,
        'iframe': `${iframe}`,

      }
    });
  }

  // private addApiKey(request: HttpRequest<string>) {
  //   // Add the api-key to the request headers
  //   const apiKey = environment.api_key;  // replace with your actual API key
  //   return request.clone({
  //     setHeaders: {
  //       'api-key': apiKey
  //     }
  //   });
  // }
}
